module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "sd-fravaer text-dark"
  }, [_c('h2', {
    staticClass: "marg-1-bottom capitalize"
  }, [_vm._v("Fraværsindberetninger")]), _vm._v(" "), (_vm.isNoConfiguration) ? [_vm._m(0)] : [_c('div', {
    staticClass: "sd-fravaer__header"
  }, [_c('div', {
    staticClass: "sd-fravaer__header__left"
  }, [_c('Tabs', {
    attrs: {
      "tabs": _vm.viewTabs,
      "selected": _vm.viewTab
    },
    on: {
      "select": _vm.onSelectViewTab
    }
  }), _vm._v(" "), (_vm.viewTab === 'employments') ? [_c('DoFiltersFilter', {
    attrs: {
      "title": 'Personer',
      "tags": _vm.personNames,
      "selectedTags": _vm.selectedPersonNames,
      "numberOfSelectedTagsToShow": 1,
      "placeholder": 'Vælg personer'
    },
    on: {
      "select": _vm.togglePersonName,
      "clear": function($event) {
        _vm.selectedPersonNames = []
      }
    }
  }), _vm._v(" "), _c('DoFiltersFilter', {
    attrs: {
      "title": 'Grupper',
      "tags": _vm.userTags,
      "selectedTags": _vm.selectedUserTags,
      "numberOfSelectedTagsToShow": 1,
      "placeholder": 'Vælg grupper'
    },
    on: {
      "select": _vm.toggleUserTag,
      "clear": function($event) {
        _vm.selectedUserTags = []
      }
    }
  }), _vm._v(" "), (_vm.employmentTitles.length > 1) ? _c('DoFiltersFilter', {
    attrs: {
      "title": 'Ansættelser',
      "tags": _vm.employmentTitles,
      "selectedTags": _vm.selectedEmploymentTitles,
      "numberOfSelectedTagsToShow": 1,
      "placeholder": 'Vælg stilling'
    },
    on: {
      "select": _vm.toggleEmploymentTitle,
      "clear": function($event) {
        _vm.selectedEmploymentTitles = []
      }
    }
  }) : _vm._e(), _vm._v(" "), (_vm.organisations.length > 1) ? _c('DoFiltersFilter', {
    attrs: {
      "title": 'Organisationer',
      "tags": _vm.organisations,
      "selectedTags": _vm.selectedOrganisations,
      "numberOfSelectedTagsToShow": 1,
      "placeholder": 'Vælg organisation'
    },
    on: {
      "select": _vm.toggleOrganisation,
      "clear": function($event) {
        _vm.selectedOrganisations = []
      }
    }
  }) : _vm._e(), _vm._v(" "), _c('span', {
    staticClass: "sd-fravaer__count"
  }, [_vm._v("\n            Viser " + _vm._s(_vm.filteredRows.length) + " af " + _vm._s(_vm.allRows.length) + " ansættelser\n          ")])] : [_c('DoFiltersFilter', {
    attrs: {
      "title": 'Personer',
      "tags": _vm.uniqueNames,
      "selectedTags": _vm.selectedNames,
      "numberOfSelectedTagsToShow": 2,
      "placeholder": 'Vælg personer'
    },
    on: {
      "select": _vm.toggleName,
      "clear": function($event) {
        _vm.selectedNames = []
      }
    }
  }), _vm._v(" "), _c('DoFiltersFilter', {
    attrs: {
      "title": 'Fraværstype',
      "tags": _vm.uniqueAbsenceTypes,
      "selectedTags": _vm.selectedAbsenceTypes,
      "numberOfSelectedTagsToShow": 2,
      "placeholder": 'Vælg fraværstype'
    },
    on: {
      "select": _vm.toggleAbsenceType,
      "clear": function($event) {
        _vm.selectedAbsenceTypes = []
      }
    }
  })]], 2), _vm._v(" "), (_vm.viewTab !== 'employments') ? _c('div', {
    staticClass: "sd-fravaer__header__right"
  }, [_c('button', {
    staticClass: "do-bttn do-bttn--small",
    attrs: {
      "disabled": _vm.isLoading
    },
    on: {
      "click": _vm.readFravaer
    }
  }, [_vm._v("\n          Opdater\n        ")])]) : _vm._e()]), _vm._v(" "), (_vm.viewTab === 'employments') ? _c('div', {
    staticClass: "sd-fravaer__toolbar"
  }, [_c('DoDatePickerRange', {
    attrs: {
      "allowSameDate": true,
      "startDate": _vm.autoStartDate,
      "endDate": _vm.autoEndDate,
      "maximumDateRange": 365
    },
    on: {
      "startChanged": function($event) {
        _vm.autoStartDate = $event
      },
      "endChanged": function($event) {
        _vm.autoEndDate = $event
      }
    }
  }), _vm._v(" "), _c('button', {
    staticClass: "do-bttn",
    staticStyle: {
      "font-size": "11px"
    },
    on: {
      "click": _vm.openAutomaticIndberetning
    }
  }, [_vm._v("\n        Indberet fravær\n      ")])], 1) : _vm._e(), _vm._v(" "), (_vm.viewTab === 'outbox') ? _c('div', {
    staticClass: "sd-fravaer__info"
  }, [_vm._v("\n      Fraværsindberetninger i udbakken sendes automatisk til SD senere på dagen. Du kan slette dem, så længe de ligger her.\n    ")]) : _vm._e(), _vm._v(" "), _c('div', {
    staticClass: "sd-fravaer__body"
  }, [(_vm.viewTab === 'employments') ? [(_vm.isLoadingEmployments) ? _c('Loader') : _c('table', {
    staticClass: "do-table"
  }, [_c('thead', [_c('tr', [_c('th', [_vm._v("NAVN")]), _vm._v(" "), _c('th', [_vm._v("ANSÆTTELSE")]), _vm._v(" "), _c('th', [_vm._v("ORGANISATION")])])]), _vm._v(" "), (_vm.filteredRows.length === 0) ? _c('tbody', [_c('tr', [_c('td', {
    staticClass: "italic",
    attrs: {
      "colspan": 3
    }
  }, [_vm._v("Ingen ansættelser fundet")])])]) : _vm._e(), _vm._v(" "), _vm._l((_vm.groupedRows), function(group) {
    return _c('tbody', {
      key: group.userId,
      staticClass: "user-group"
    }, _vm._l((group.rows), function(row) {
      return _c('tr', {
        key: row.id,
        staticClass: "employment-row"
      }, [_c('td', {
        staticClass: "bold"
      }, [_vm._v(_vm._s(row.userName))]), _vm._v(" "), _c('td', {
        staticClass: "td-organisation"
      }, [_vm._v("\n              " + _vm._s(row.employmentNumber) + " - " + _vm._s(row.employmentTitle) + "\n            ")]), _vm._v(" "), _c('td', {
        staticClass: "td-organisation"
      }, [_vm._v(_vm._s(row.organisation))])])
    }), 0)
  })], 2)] : [(_vm.isLoading) ? _c('Loader') : _c('table', {
    staticClass: "do-table do-table--striped"
  }, [_c('thead', [_c('tr', [_c('th', {
    staticClass: "td-created"
  }, [_vm._v("OPRETTET")]), _vm._v(" "), _c('th', [_vm._v("NAVN")]), _vm._v(" "), _c('th', [_vm._v("ANSÆTTELSE")]), _vm._v(" "), _c('th', [_vm._v("FRAVÆRSTYPE")]), _vm._v(" "), _c('th', {
    staticClass: "td-date"
  }, [_vm._v("DATO")]), _vm._v(" "), _c('th', {
    staticClass: "td-units"
  }, [_vm._v("DAGE")]), _vm._v(" "), _c('th', {
    staticClass: "td-units"
  }, [_vm._v("TIMER")]), _vm._v(" "), _c('th', {
    staticClass: "td-created-by"
  }, [_vm._v("OPRETTET AF")]), _vm._v(" "), _c('th', {
    staticClass: "td-status"
  }, [_vm._v("STATUS")]), _vm._v(" "), _c('th', {
    staticClass: "th-actions"
  })])]), _vm._v(" "), _c('tbody', [(_vm.displayedRows.length === 0) ? _c('tr', [_c('td', {
    staticClass: "italic",
    attrs: {
      "colspan": 10
    }
  }, [_vm._v("\n              " + _vm._s(_vm.viewTab === 'outbox' ? 'Udbakken er tom' : 'Ingen afsendte fraværsindberetninger') + "\n            ")])]) : _vm._e(), _vm._v(" "), _vm._l((_vm.displayedRows), function(item) {
    return _c('tr', {
      key: item.vKey,
      staticClass: "fravaer-row"
    }, [_c('td', {
      staticClass: "td-created"
    }, [_vm._v(_vm._s(item.vCreatedAt))]), _vm._v(" "), _c('td', [_vm._v(_vm._s(item.vUserName))]), _vm._v(" "), _c('td', [_vm._v(_vm._s(item.vEmploymentNumber))]), _vm._v(" "), _c('td', [_vm._v(_vm._s(item.vAbsenceType))]), _vm._v(" "), _c('td', {
      staticClass: "td-date"
    }, [_vm._v(_vm._s(item.vDato))]), _vm._v(" "), _c('td', {
      staticClass: "td-units"
    }, [_vm._v(_vm._s(_vm.formatDecimal(item.dage)))]), _vm._v(" "), _c('td', {
      staticClass: "td-units"
    }, [_vm._v(_vm._s(_vm.formatDecimal(item.timer)))]), _vm._v(" "), _c('td', {
      staticClass: "td-created-by"
    }, [_vm._v(_vm._s(item.vCreatedBy))]), _vm._v(" "), _c('td', {
      staticClass: "td-status"
    }, [_c('span', {
      staticClass: "status-pill",
      class: 'status-pill--' + item.state
    }, [_vm._v(_vm._s(_vm.stateLabel(item.state)))])]), _vm._v(" "), _c('td', {
      staticClass: "td-actions"
    }, [(_vm.viewTab === 'outbox' && item.can_delete) ? _c('button', {
      staticClass: "do-bttn do-bttn--small do-bttn--danger",
      attrs: {
        "disabled": _vm.deletingIds.includes(item.vKey)
      },
      on: {
        "click": function($event) {
          $event.stopPropagation();
          return _vm.deleteRow(item)
        }
      }
    }, [_vm._v("\n                Slet\n              ")]) : _vm._e()])])
  })], 2)])]], 2)], _vm._v(" "), (_vm.isAutoFravaerOpen) ? _c('SdAutoFravaer', {
    attrs: {
      "schoolId": _vm.schoolId,
      "absenceCodes": _vm.absenceCodes,
      "startDate": _vm.autoStartDate,
      "endDate": _vm.autoEndDate
    },
    on: {
      "startChanged": function($event) {
        _vm.autoStartDate = $event
      },
      "endChanged": function($event) {
        _vm.autoEndDate = $event
      },
      "created": _vm.onAutoFravaerCreated,
      "close": function($event) {
        _vm.isAutoFravaerOpen = false
      }
    }
  }) : _vm._e(), _vm._v(" "), (_vm.deleteCandidate) ? _c('ModalConfirmation', {
    attrs: {
      "showClose": false,
      "isSubmitButtonLoading": _vm.deletingIds.includes(_vm.deleteCandidate.vKey)
    },
    on: {
      "close": function($event) {
        _vm.deleteCandidate = null
      },
      "confirm": _vm.confirmDeleteRow
    }
  }, [_c('div', {
    staticClass: "delete-confirm__details",
    attrs: {
      "slot": "custom_warning"
    },
    slot: "custom_warning"
  }, [_vm._v("\n      " + _vm._s(_vm.deleteCandidate.vUserName) + " – " + _vm._s(_vm.deleteCandidate.vAbsenceType) + " (" + _vm._s(_vm.deleteCandidate.vDato) + ")\n    ")])]) : _vm._e()], 2)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "sd-fravaer-no-config"
  }, [_c('h2', [_c('i', [_vm._v("Skolens Silkeborg Data-integration er ikke konfigureret korrekt. Kontakt Docendo for at få hjælp til\n          opsætningen - enten på chat eller email.")])])])
}]}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler.js?id=data-v-07c581fb!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/Salary/Silkeborgdata/SdFravaer.vue
// module id = 1748
// module chunks = 1